import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState(location.state?.user ? "ok" : "checking");
  const [user, setUser] = useState(location.state?.user || null);

  useEffect(() => {
    if (state === "ok") return;
    (async () => {
      try {
        const res = await api.get("/auth/me");
        setUser(res.data);
        setState("ok");
      } catch {
        setState("no");
        navigate("/", { replace: true });
      }
    })();
  }, [state, navigate]);

  if (state !== "ok") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 text-sm animate-pulse" data-testid="protected-loading">Cargando…</div>
      </div>
    );
  }
  // Inject user via context prop
  return typeof children === "function" ? children(user) : (
    <UserContext user={user}>{children}</UserContext>
  );
}

function UserContext({ user, children }) {
  return <div data-user-email={user?.email}>{children}</div>;
}
